import { getTheme } from '@dora/vivian';
import { ThemeProvider } from '@mui/material/styles';
import * as Preact from 'preact';
import Helmet from 'preact-helmet';
import { useSelector } from '../store/redux';
import * as Selectors from '../store/selectors';

export const ThemeBuilder = (props: { children: Preact.ComponentChildren }) => {
    // Setting theme and helmet in this component ensures errors thrown outside 'Routes' are also stylised
    const brandColour = useSelector(Selectors.Core.brandColour);
    const theme = getTheme(brandColour);

    return (
        <>
            <Helmet
                link={[
                    {
                        rel: 'stylesheet',
                        href: 'https://fonts.googleapis.com/css2?family=Inter+Tight:ital,wght@0,100..900;1,100..900&display=swap',
                    },
                ]}
                meta={[
                    {
                        name: 'viewport',
                        content: 'width=device-width, initial-scale=1',
                    },
                    { name: 'og:title', content: '' }, // TODO: Meta tags
                    { name: 'og:description', content: '' },
                    { name: 'og:image', content: `` },
                ]}
                style={[
                    {
                        type: 'text/css',
                        cssText: 'body {height: 100vh; margin: 0; overflow: hidden}',
                    },
                ]}
            />
            <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
        </>
    );
};
